import React from "react";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import { TFunction } from "i18next";
import { ILocalAssessment, ILocalTest } from "./helpers";
import AddTestToAssessmentLocal from "./AddTestToAssessmentLocal";
import TestsList from "./TestsList";
import StageRulesDisplay from "./StageRulesDisplay";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";

interface IAssessmentCardProps {
    assessment: ILocalAssessment;
    onEdit: () => void;
    onDelete: () => void;
    onAddTest: (test: ILocalTest) => void;
    onDeleteTest: (testId: string) => void;
    tLocal: TFunction;
}

const AssessmentCard = (props: IAssessmentCardProps) => {
    const {
        assessment,
        onEdit,
        onDelete,
        onAddTest,
        onDeleteTest,
        tLocal
    } = props;

    const existingTestNames = assessment.tests.map((test) => test.testName);

    return (
        <Card
            style={{
                margin: 16,
                display: "flex",
                flexDirection: "column",
                width: "100%"
            }}
        >
            <CardContent
                style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <Box
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Typography
                        variant="h6"
                        component="h2"
                        gutterBottom
                        style={{ fontWeight: 700 }}
                    >
                        {assessment.name}
                    </Typography>
                    <Box flexGrow={1} />
                    <ButtonIconTooltipCompleo
                        label={tLocal("edit") || "Edit"}
                        onClick={onEdit}
                    >
                        <Edit />
                    </ButtonIconTooltipCompleo>
                    {assessment.tests.length === 0 && (
                        <ButtonIconTooltipCompleo
                            label={tLocal("delete") || "Delete"}
                            onClick={onDelete}
                        >
                            <Delete color="secondary" />
                        </ButtonIconTooltipCompleo>
                    )}
                    <AddTestToAssessmentLocal
                        existingTestNames={existingTestNames}
                        onAddTest={onAddTest}
                        tLocal={tLocal}
                    />
                </Box>
                <StageRulesDisplay
                    resultsToStageRule={assessment.resultsToStageRule}
                    tLocal={tLocal}
                />
                <TestsList
                    tests={assessment.tests}
                    onDeleteTest={onDeleteTest}
                    tLocal={tLocal}
                />
            </CardContent>
        </Card>
    );
};

export default AssessmentCard;
